var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7314 20.4353L15.4752 14.179C16.687 12.6821 17.4167 10.78 17.4167 8.70835C17.4167 3.90685 13.5098 0 8.7083 0C3.9068 0 0 3.9068 0 8.7083C0 13.5098 3.90685 17.4167 8.70835 17.4167C10.78 17.4167 12.6821 16.687 14.179 15.4752L20.4353 21.7314C20.614 21.9102 20.8487 22 21.0833 22C21.318 22 21.5527 21.9102 21.7314 21.7314C22.0898 21.373 22.0898 20.7937 21.7314 20.4353ZM8.70835 15.5833C4.917 15.5833 1.83335 12.4997 1.83335 8.7083C1.83335 4.91696 4.917 1.8333 8.70835 1.8333C12.4997 1.8333 15.5833 4.91696 15.5833 8.7083C15.5833 12.4997 12.4997 15.5833 8.70835 15.5833Z",
    fill: "white",
    fillOpacity: 0.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.54f0860f.svg";
export { ForwardRef as ReactComponent };